var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.name)?_c('p',{staticClass:"player-title"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('audio',{ref:"audio",attrs:{"controls":"","playsinline":"","src":_vm.src || _vm.currSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }